<script setup lang="ts">
// A form field's frame: an uppercase label above, the control in the slot, and help
// or an error under it. `for` ties the label to the control's id.
defineProps<{ label: string; for?: string | undefined; help?: string | undefined; error?: string | undefined }>();
</script>

<template>
  <div class="itc-field" :class="{ 'itc-field--error': error }">
    <label class="itc-field-label" :for="$props.for">{{ label }}</label>
    <slot />
    <div v-if="error" class="itc-field__error" role="alert">{{ error }}</div>
    <div v-else-if="help" class="itc-field__help">{{ help }}</div>
  </div>
</template>

<style scoped>
.itc-field__help,
.itc-field__error {
  font-size: 13px;
  color: var(--itc-muted);
}
.itc-field__error {
  color: var(--itc-crit);
}
.itc-field--error :deep(.itc-input),
.itc-field--error :deep(.itc-select) {
  border-color: var(--itc-crit);
}
</style>
